import { Text } from "@/components/atoms/Text";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/molecules/Tooltip";
import { cn } from "@/lib/utils";
import { DayContentProps } from "react-day-picker";

type AvailabilityBarProps = {
  isPartiallyBlocked: boolean;
  isSelectedDay?: boolean;
};

const AvailabilityBar = ({
  isPartiallyBlocked,
  isSelectedDay,
}: AvailabilityBarProps) => {
  return (
    <span
      className={cn(
        "tw-absolute tw-h-2 tw-w-16 tw-rounded-8 -tw-bottom-4 tw-bg-gray-600 tw-left-1/2 -tw-translate-x-1/2",
        {
          "tw-hidden": !isPartiallyBlocked,
          "tw-bg-gray-700": isSelectedDay,
        },
      )}
    >
      <span
        className={cn(
          "tw-absolute tw-inset-0 tw-bg-gray-400 tw-rounded-tl-8 tw-rounded-bl-8 tw-hidden tw-w-1/2",
          {
            "tw-inline-block": isPartiallyBlocked,
            "tw-bg-gray-600": isSelectedDay,
          },
        )}
      />
    </span>
  );
};

export const CalendarAvailabilityDayContent = ({
  date,
  activeModifiers,
}: DayContentProps) => {
  const isPartiallyBlocked =
    activeModifiers?.partiallyBooked &&
    !activeModifiers?.disabled &&
    !activeModifiers?.fullyBooked;

  const Content = (
    <span
      className={cn("tw-size-full tw-flex tw-items-center tw-justify-center", {
        "!tw-text-gray-500 tw-line-through tw-pointer-events-none":
          activeModifiers?.fullyBooked,
      })}
    >
      <span className="tw-relative">
        {date.getDate()}
        <AvailabilityBar
          isPartiallyBlocked={isPartiallyBlocked}
          isSelectedDay={activeModifiers?.selected}
        />
      </span>
    </span>
  );

  return !isPartiallyBlocked ? (
    Content
  ) : (
    <Tooltip>
      <TooltipTrigger asChild>{Content}</TooltipTrigger>
      <TooltipContent side="bottom">
        <Text typeface="body-1" className="tw-text-gray-900">
          Partially booked
        </Text>
        <TooltipArrow className="tw-fill-base-white" />
      </TooltipContent>
    </Tooltip>
  );
};
